import { useContext } from "react";
import { Context } from "../../App";
import styles from "./box.module.scss";

export default function DetailedBox() {
  const {data} = useContext(Context);

  return (
    <div className={styles.container}>
      {data && (
        <div className={styles.details}>
          <div className={styles.detail}>
            <div className={styles.title}>ip address</div>
            {data.ip}
          </div>
          <div className={styles.detail}>
            <div className={styles.title}>location</div>
            {data.location.city}, {data.location.region}
          </div>
          <div className={styles.detail}>
            <div className={styles.title}>time zone</div>
            {data.location.timezone}
          </div>
          <div className={styles.detail}>
            <div className={styles.title}>isp</div>
            {data.isp}
          </div>
        </div>
      )}
    </div>
  );
}
